import { createReducer } from '../utils';
import {
  HIDE_SNACKBAR,
  CUSTOM_SNACKBAR,
  SNACKBAR_SUCCESS,
  SNACKBAR_ERROR,
  SNACKBAR_WARNING,
  SNACKBAR_INFO,
  SNACK_SET,
} from '../constants';

// Dispatches snack for both platforms: CUSTOM_SNACKBAR (mobile) + SNACK_SET (web)
export function dispatchSnack(dispatch, text, color) {
  dispatch({ type: CUSTOM_SNACKBAR, payload: { text, color } });
  dispatch({ type: SNACK_SET, payload: { snack: { open: true, translation_key: text, severity: color } } });
}

const defaultState = {
  content: '',
  visible: false,
  color: 'info',
};

// reducer

export const reducer = createReducer(defaultState, {
  [HIDE_SNACKBAR]: handleHideSnackbar,
  [CUSTOM_SNACKBAR]: handleCustomSnackbar,
  [SNACKBAR_SUCCESS]: handleSnackbarSuccess,
  [SNACKBAR_ERROR]: handleSnackbarError,
  [SNACKBAR_WARNING]: handleSnackbarWarning,
  [SNACKBAR_INFO]: handleSnackbarInfo,
});

function handleHideSnackbar(state, action) {
  return {
    ...state,
    visible: false,
  };
}

function handleCustomSnackbar(state, { payload: { text, color } }) {
  return {
    ...state,
    visible: true,
    content: text,
    color: color,
  };
}

function handleSnackbarSuccess(state, { payload: { text } }) {
  return {
    ...state,
    visible: true,
    content: text,
    color: 'success',
  };
}

function handleSnackbarError(state, { payload: { text } }) {
  return {
    ...state,
    visible: true,
    content: text,
    color: 'error',
  };
}

function handleSnackbarWarning(state, { payload: { text } }) {
  return {
    ...state,
    visible: true,
    content: text,
    color: 'warning',
  };
}

function handleSnackbarInfo(state, { payload: { text } }) {
  return {
    ...state,
    visible: true,
    content: text,
    color: 'info',
  };
}
// actions

export function hideSnackbar() {
  return async (dispatch, getState, { services: {} }) => {
    try {
      dispatch({ type: HIDE_SNACKBAR });
    } catch (error) {
      console.log(error);
    }
  };
}

export function customSnackbar(text, color) {
  return async (dispatch, getState, { services: {} }) => {
    try {
      dispatch({ type: CUSTOM_SNACKBAR, payload: { text, color } });
    } catch (error) {
      console.log(error);
    }
  };
}

export function snackbarSuccess(text) {
  return async (dispatch, getState, { services: {} }) => {
    try {
      dispatch({ type: SNACKBAR_SUCCESS, payload: { text } });
    } catch (error) {
      console.log(error);
    }
  };
}

export function snackbarError(text) {
  return async (dispatch, getState, { services: {} }) => {
    try {
      dispatch({ type: SNACKBAR_ERROR, payload: { text } });
    } catch (error) {
      console.log(error);
    }
  };
}

export function snackbarWarning(text) {
  return async (dispatch, getState, { services: {} }) => {
    try {
      dispatch({ type: SNACKBAR_WARNING, payload: { text } });
    } catch (error) {
      console.log(error);
    }
  };
}

export function snackbarInfo(text) {
  return async (dispatch, getState, { services: {} }) => {
    try {
      dispatch({ type: SNACKBAR_INFO, payload: { text } });
    } catch (error) {
      console.log(error);
    }
  };
}
